<template>
  <div class="px-4 w-full mx-auto max-w-[1600px]">
    <slot></slot>
  </div>
</template>
